module.exports = __webpack_public_path__ + "img/FE.eac3de17.svg";